<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Survey</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Marketing</b>
      /
      <b>Survey</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12"></div>

      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
        <div class="btn-group" role="group">
          <button
            class="btn btn-secondary"
            id="btn-active"
            type="button"
            :class="{ 'change-background': activeClick }"
            @click="clickActive()"
          >
            Active
          </button>
          <button
            class="btn btn-secondary"
            id="btn-inactive"
            type="button"
            :class="{ 'change-background': inactiveClick }"
            @click="clickInactive()"
          >
            Inactive
          </button>
        </div>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Survey</h4>

            <div class="row col-12">
              <div class="col-8">
                <router-link
                  :to="{ name: 'survey-add' }"
                  type="button"
                  class="btn btn-primary mb-2"
                  >Add</router-link
                >
              </div>
            </div>

            <div class="table-responsive">
              <table
                id="surveys_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Survey Name</th>
                    <th>Survey Type</th>
                    <th>TBM Point</th>
                    <th>Respondents</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(survey, index) in rows" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ survey.survey_title }}</td>
                    <td>{{ checkSurveyType(survey.type) }}</td>
                    <td>{{ survey.points }}</td>
                    <td>{{ survey.respondents }}</td>
                    <td>{{ checkStatus(survey.active) }}</td>
                    <td>
                      <router-link
                        :to="{ name: 'survey-edit', params: { id: survey.id } }"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Details</router-link
                      >
                      <router-link
                        :to="{ name: 'view-answer', params: { id: survey.id } }"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Answer</router-link
                      >
                      <router-link
                        :to="{
                          name: 'survey-report',
                          params: { id: survey.id }
                        }"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Report</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "survey-view",
  components: {},

  data() {
    return {
      rows: [],
      activeSurveys: [],
      inactiveSurveys: [],
      activeClick: true,
      inactiveClick: false
    };
  },

  methods: {
    async loadActiveSurveys() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        try {
          let result = await axios.get(axios.lpsURL + "/survey_user/status/1", {
            headers: {
              Authorization: "Bearer " + token
            }
          });
          this.activeSurveys = result.data;
        } catch (error) {
          console.log(error);
        }
      }
    },

    async loadInactiveSurveys() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        try {
          let result = await axios.get(axios.lpsURL + "/survey_user/status/0", {
            headers: {
              Authorization: "Bearer " + token
            }
          });
          this.inactiveSurveys = result.data;
        } catch (error) {
          console.log(error);
        }
      }
    },

    async insertActive() {
      this.rows = this.activeSurveys;
    },

    async insertInactive() {
      this.rows = this.inactiveSurveys;
    },

    async clickActive() {
      this.activeClick = true;
      this.inactiveClick = false;
      await this.killDatatable();
      await this.insertActive();
      this.createDatatable();
    },

    async clickInactive() {
      this.activeClick = false;
      this.inactiveClick = true;
      await this.killDatatable();
      await this.insertInactive();
      this.createDatatable();
    },

    checkSurveyType(str) {
      switch (str) {
        case "1":
          return "Product Purchase Survey";
        case "2":
          return "General";
        default:
          return "None";
      }
    },

    checkStatus(int) {
      switch (int) {
        case 0:
          return "Inactive";
        case 1:
          return "Active";
        default:
          return "Inactive";
      }
    },

    async killDatatable() {
      $("#surveys_tbl")
        .DataTable()
        .destroy();
    },

    async createDatatable() {
      $("#surveys_tbl").DataTable({
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5]
            }
          }
        ]
      });
    }
  },

  async created() {
    await this.loadActiveSurveys();
    await this.loadInactiveSurveys();
    await this.insertActive();
    this.createDatatable();
  },

  mounted() {}
};
</script>

<style>
.change-background {
  background-color: #5f5f5f;
  color: white;
}
</style>
